export default __webpack_public_path__ + "static/media/esd.0ae5b3db.jpg";